<template>
  <div>
    <v-toolbar color="#f5f5f5">
      <img src="/img/logo.png" height="80%" alt="Controller - Monitoramento Solar">
      <v-spacer></v-spacer>
      <v-btn dark rounded small color="red darken-2" :to="{ name: 'logout' }">
        Sair
      </v-btn>
    </v-toolbar>

    <v-card flat tile class="text-center pl-2 pr-2 pb-2 menu-wrapper">
      <v-btn small rounded depressed color="primary" :to="{ name: 'adminDashboard' }" class="mr-2">Dashboard</v-btn>
      <v-btn small rounded depressed color="primary" :to="{ name: 'adminProject' }" class="mr-2">Clientes</v-btn>
      <v-btn small rounded depressed color="primary" :to="{ name: 'adminPlan' }" class="mr-2">Planos</v-btn>
    </v-card>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.menu-wrapper {
  .v-btn {
    margin-top: 8px;
  }
}
</style>
